export const UPDATE_THEME = 'theme.UPDATE_THEME'



// WEBPACK FOOTER //
// ./src/store/theme/types.js